import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

import React, { useMemo } from 'react';
import { Carousel as ReactResponsiveCarousel } from 'react-responsive-carousel';

import {
	caption as captionStyle,
	carousel as carouselStyle,
	image as imageStyle,
	item as itemStyle,
} from './style.module.css';

interface CarouselItem {
	title: string;
	url: string;
}
interface CarouselProps {
	items?: CarouselItem[];
}

export const Carousel = ({ items }: CarouselProps): JSX.Element => {
	if (!Array.isArray(items)) return <></>;

	const images = useMemo(
		() =>
			items.map((item) => (
				<div className={itemStyle}>
					<img className={imageStyle} src={item.url} />
					<p className={captionStyle}>{item.title}</p>
				</div>
			)),
		[items]
	);
	return (
		<ReactResponsiveCarousel
			showThumbs={false}
			showStatus={false}
			showIndicators
			className={carouselStyle}
		>
			{images}
		</ReactResponsiveCarousel>
	);
};
